const tabsButtons = document.querySelectorAll('.tab-heading');
if (tabsButtons) {
  const tabsContents = document.querySelectorAll('.tab-content');
  const tabsBack = document.querySelector('.block-item.back-button');

  // Initially hide all tab contents
  tabsContents.forEach((content) => {
    content.classList.add("hidden");
  });

  tabsButtons.forEach((tab) => {
    tab.addEventListener("click", function () {
      const itemDataTab = tab.getAttribute("data-tab");
        // Hide all tabs and remove active class
      tabsButtons.forEach((tab) => {
        tab.classList.add("hidden")
        tab.classList.remove("active");
      });
      // Show the selected tab content
      tabsContents.forEach((content) => {
        const dataTab = content.getAttribute("data-tab");
        if (itemDataTab === dataTab) {
          scroll_function('.blocks-wrapper'); // Call your scroll function
          tab.classList.remove("hidden"); // Show the selected tab
          tab.classList.add("active");
          content.classList.remove("hidden"); // Show corresponding content
          tabsBack.classList.remove("hidden");// Show tabsBack element
          adjustBackButton(tab);
        }
        });
      });
    });

  // Add event listeners for back button
  if (tabsBack) {
    tabsBack.addEventListener("click", function () {
        // Hide all tab contents
        tabsContents.forEach((content) => {
          content.classList.add("hidden");
        });

        // Show all tab headings and remove active class
        tabsButtons.forEach((tab) => {
          tab.classList.remove("hidden");
          tab.classList.remove("active");
        });

        tabsBack.classList.add("hidden");
        });
    }
  }

  //international deliveries
  const countrySelect = document.getElementById("countrySelect");
  const rows = document.querySelectorAll("#deliveryTableBody tr");

  function filterTableByCountry(selectedCountry) {
    rows?.forEach(row => {
      const rowCountry = row?.getAttribute("data-country");
      if (selectedCountry === rowCountry) {
        row.style.display = "";
      } else {
        row.style.display = "none";
      }
    });
  }

  function adjustBackButton() {
    const tabsBack = document.querySelector('.block-item.back-button');
    const tabEle = document.querySelector('.tab-heading.active');
    const tabHeight = tabEle?.offsetHeight
    if (tabsBack) {
      if (window.innerWidth > 767) {
        tabsBack.style.height = tabHeight + 'px';
      } else {
        tabsBack.style.height = 'auto';
      }
      if (window.innerWidth < 749) {
        tabHeight > 66 ? tabsBack.style.top = '100px' : tabsBack.style.top = '80px'
      } else {
        tabsBack.style.top = 'auto' 
      }
    }
  }

  window.addEventListener("resize", adjustBackButton);

  // Show data for the default selected country when the page loads
  const defaultSelectedCountry = countrySelect?.options[countrySelect.selectedIndex].getAttribute('data-option');
  filterTableByCountry(defaultSelectedCountry);

  // Update the table when a new country is selected
  countrySelect?.addEventListener("change", function() {
    const selectedCountry = this.options[this.selectedIndex]?.getAttribute('data-option');
    filterTableByCountry(selectedCountry);

  });

  // Faq section navigation 
  const navigationElements = document.querySelectorAll('.faqs-section .content-navigation');
  navigationElements?.forEach((each) => {
    each?.addEventListener('click', () => {
      const contentId = each.getAttribute('tab-id');
      const navigationContent = document.querySelector(`.faqs-section #${contentId}`);
      if (navigationContent) {
        // Get the distance of the element from the top of the page
        const distanceFromTop = navigationContent.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: distanceFromTop - 200,
          behavior: 'smooth'
        });
      }
    })
  })


//scroll function
function scroll_function(href) {
  var header_Height = document.querySelector('.section-header').offsetHeight;
  var element = document.querySelector(href);
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - header_Height;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}
